import React, { useEffect, useState } from "react"
import { Col, Row } from "reactstrap"
import toast from "react-hot-toast"

import { Modal } from "../../../components/Modal"
import { Button } from "../../../components/Button"
import { AutoComplete } from "../../../components/AutoComplete"
import autoCompleteStyles from "../../../components/AutoComplete/autoCompleteStyles"
import { CreateTrailerBaseFeatureCategory } from "../../../api/api.service"

const ManageImportGlobalFeatureModal = ({
   isOpen = false,
   onToggleModal = () => {},
   baseFeaturesOptions = {},
   setBaseFeaturesOptions = () => {},
   handleSearchBaseFeature = () => {},
   selectedBaseFeatures = [],
   setSelectedBaseFeatures = () => {},
   trailerId = "",
   onSuccess = () => {},
   existingTrailerBaseFeatures = [],
}) => {
   const [isLoading, setIsLoading] = useState(false)
   const [existingBaseFeatureIds, setExistingBaseFeatureIds] = useState([])

   useEffect(() => {
      const ids = existingTrailerBaseFeatures
         .map(feature => feature.globalBaseFeatureId)
         .filter(id => id !== null)
      setExistingBaseFeatureIds(ids)
   }, [existingTrailerBaseFeatures])

   const handleSelectFeatures = selectedOptions => {
      setSelectedBaseFeatures(selectedOptions || [])
   }

   const handleRemoveChip = featureToRemove => {
      const updatedFeatures = selectedBaseFeatures.filter(
         feature => feature.value !== featureToRemove.value
      )
      setSelectedBaseFeatures(updatedFeatures)
   }

   const handleSubmit = async () => {
      if (!selectedBaseFeatures || selectedBaseFeatures.length === 0) {
         toast.error("Please select at least one base feature")
         return
      }

      try {
         setIsLoading(true)
         const featureIds = selectedBaseFeatures.map(feature => feature.value)

         const payload = {
            configuratorTrailerId: Number(trailerId),
            globalBaseFeatureIds: featureIds,
         }

         await CreateTrailerBaseFeatureCategory(payload)
         toast.success(
            `${selectedBaseFeatures.length} base feature(s) added successfully!`
         )
         onToggleModal()
         setSelectedBaseFeatures([])
         onSuccess()
      } catch (error) {
         toast.error("Failed to add base features")
      } finally {
         setIsLoading(false)
      }
   }

   const handleModalClose = () => {
      setSelectedBaseFeatures([])
      setBaseFeaturesOptions(prev => {
         return {
            ...prev,
            page: 1,
            Q: "",
         }
      })
      onToggleModal()
   }

   return (
      <Modal
         isOpen={isOpen}
         handleModalToggling={handleModalClose}
         bodyClassName=""
         customButton={true}
         hideModalHeaderSeparator={true}
         headerClasses="header-container mb-0"
         size="md"
         backdrop="static"
         modalTitle="Select Base Features"
         scrollable
      >
         <div style={{ pointerEvents: isLoading ? "none" : "auto" }}>
            <Row>
               <Col xs={12}>
                  <div className="mb-3">
                     <AutoComplete
                        isMulti
                        handleBlur={() =>
                           setBaseFeaturesOptions(prev => {
                              return {
                                 ...prev,
                                 page: 1,
                                 Q: "",
                              }
                           })
                        }
                        onChange={handleSelectFeatures}
                        onInputChange={handleSearchBaseFeature}
                        placeholder="Select base features"
                        classNamePrefix="status-header-search-admin"
                        customStyles={autoCompleteStyles.STYLE_TEN}
                        options={baseFeaturesOptions?.data}
                        isClearable={true}
                        value={selectedBaseFeatures}
                        isLoading={baseFeaturesOptions?.fetching}
                        closeMenuOnSelect={false}
                        menuPortalTarget={document.body}
                        isOptionDisabled={option =>
                           existingBaseFeatureIds.includes(option.value)
                        }
                     />
                  </div>

                  <div className="mb-3">
                     <div className="Global-selected-features-container">
                        {selectedBaseFeatures &&
                        selectedBaseFeatures.length > 0 ? (
                           <div className="d-flex flex-wrap gap-2">
                              {selectedBaseFeatures.map((feature, index) => (
                                 <span
                                    key={`${feature.value}-${index}`}
                                    className="Global-feature-chip"
                                 >
                                    <span>{feature.label}</span>
                                    <button
                                       type="button"
                                       onClick={() => handleRemoveChip(feature)}
                                       aria-label="Remove"
                                       className="Global-feature-chip-remove-btn"
                                    >
                                       ×
                                    </button>
                                 </span>
                              ))}
                           </div>
                        ) : (
                           <div className="no-features-selected">
                              No features selected
                           </div>
                        )}
                     </div>
                  </div>

                  <div className="d-flex justify-content-center mt-3">
                     <Button
                        isLoading={isLoading}
                        type="button"
                        title="Save"
                        className="header-button"
                        onClick={handleSubmit}
                     />
                  </div>
               </Col>
            </Row>
         </div>
      </Modal>
   )
}

export default ManageImportGlobalFeatureModal
